import { Directive, OnDestroy } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { distinctUntilChanged, map, startWith, takeUntil, tap } from 'rxjs/operators';
import { SCREEN_SIZE_BREAKPOINTS } from '../../core/configurations/application.config';
import { APPLICATION_ACTIONS } from '../../core/store/actions/application.actions';
import { Store } from '@ngrx/store';

@Directive({
  selector: '[lhScreenSizeTracker]',
  standalone: true,
})
export class ScreenSizeTrackerDirective implements OnDestroy {
  private readonly onDestroy$: Subject<void> = new Subject<void>();
  private readonly screenSizeChanges$: Observable<number> = fromEvent(window, 'resize').pipe(
    startWith(window.innerWidth),
    map(() => window.innerWidth),
  );

  constructor(private readonly store: Store) {
    this.initScreenChangesListener();
  }

  private initScreenChangesListener(): void {
    this.screenSizeChanges$
      .pipe(
        takeUntil(this.onDestroy$),
        map((currentSize) =>
          this.getGreatestBreakpointFromArrayBySize(currentSize, Object.values(SCREEN_SIZE_BREAKPOINTS)),
        ),
        distinctUntilChanged(),
        tap((breakpoint) => this.store.dispatch(APPLICATION_ACTIONS.setScreenSize({ size: breakpoint }))),
      )
      .subscribe();
  }

  private getGreatestBreakpointFromArrayBySize(currentSize: number, breakpoints: number[]): number {
    let maxSize = 0;

    breakpoints
      .sort((pointA, pointB) => pointA - pointB)
      .forEach((point) => (maxSize = currentSize >= point ? point : maxSize));

    return maxSize;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
